import { Button } from '@/components/ui/button';

interface CalendarToolbarProps {
  rangeStart: Date;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  selectedCalendarSummary: string;
  showHubClashes: boolean;
}

function formatRangeLabel(rangeStart: Date): string {
  const rangeEnd = new Date(rangeStart);
  rangeEnd.setDate(rangeStart.getDate() + 6);

  const sameMonth = rangeStart.getMonth() === rangeEnd.getMonth() && rangeStart.getFullYear() === rangeEnd.getFullYear();
  const monthFormatter = new Intl.DateTimeFormat(undefined, { month: 'short' });
  const fullFormatter = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' });

  if (sameMonth) {
    const month = monthFormatter.format(rangeStart);
    return `${month} ${rangeStart.getDate()} - ${rangeEnd.getDate()}, ${rangeStart.getFullYear()}`;
  }

  return `${fullFormatter.format(rangeStart)} - ${fullFormatter.format(rangeEnd)}`;
}

export function CalendarToolbar({
  rangeStart,
  onPrev,
  onNext,
  onToday,
  selectedCalendarSummary,
  showHubClashes,
}: CalendarToolbarProps) {
  return (
    <div className="flex flex-col gap-3 rounded-md border bg-card p-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="text-sm text-muted-foreground">Selected calendars: {selectedCalendarSummary}</p>
        <p className="text-sm text-muted-foreground">Hub clashes: {showHubClashes ? 'Shown' : 'Hidden'}</p>
        <h2 className="text-lg font-medium">{formatRangeLabel(rangeStart)}</h2>
      </div>
      <div className="flex items-center gap-2">
        <Button type="button" variant="outline" onClick={onPrev}>
          Prev
        </Button>
        <Button type="button" variant="outline" onClick={onToday}>
          Today
        </Button>
        <Button type="button" variant="outline" onClick={onNext}>
          Next
        </Button>
      </div>
    </div>
  );
}
